import React, { useState } from 'react';
import { Empty } from 'antd';
import NoData from 'src/assets/svg/quality.svg';
import RewardList from '../../../RnRCommonComponent/RewardList/rewardListPresentation';
import useRewardDetails from '../../../RnRCommonComponent/RewardList/hooks/useRewardDetails';
import { BADGE_TYPE } from '../../../RnRCommonComponent/CoreBadge/rewardsConstants.js';

const MyBadgesList = (props) => {
	const {
		handleIconClickEvent,
		title = 'My Recognitions',
		badgeList,
		isLoading,
		hasMore,
		fetchMoreData,
		isDetailsShown = false,
		isIssuedVisible = true,
		currentUser,
		client,
		noCollapse,
	} = props;

	const [isViewRewardModalVisible, setIsViewRewardModalVisible] =
		useState(false);

	const { rewardDetails, isModalLoaderVisible, handleOpenViewReward } =
		useRewardDetails(setIsViewRewardModalVisible, currentUser, client);

	const handleCloseViewReward = () => {
		setIsViewRewardModalVisible(false);
	};

	return (
		<>
			{badgeList?.length > 0 ? (
				<RewardList
					handleIconClickEvent={handleIconClickEvent}
					title={title}
					badgeType={BADGE_TYPE.PEERTOPEER}
					hasMore={hasMore}
					isLoading={isLoading}
					badgeList={badgeList}
					fetchMoreData={fetchMoreData}
					isDetailsShown={isDetailsShown}
					isPointsShown={true}
					handleCloseViewReward={handleCloseViewReward}
					isViewRewardModalVisible={isViewRewardModalVisible}
					rewardDetails={rewardDetails}
					isModalLoaderVisible={isModalLoaderVisible}
					handleOpenViewReward={handleOpenViewReward}
					getMyBadge={true}
					isIssuedVisible={isIssuedVisible}
					noCollapse={noCollapse}
				/>
			) : (
				<div className="d-card" style={{ height: '100%' }}>
					<div className="d-card-head">
						<h4 className="d-title-no-case">{title}</h4>
					</div>
					<div
						className="d-card-body"
						style={{
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<Empty
							style={{
								height: '360px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								flexDirection: 'column',
							}}
							className="recognition-empty"
							image={
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
									className="my-sent-activity-empty"
								>
									<img src={NoData} alt="img"></img>
								</div>
							}
							description={
								<div
									className="no-badges-state"
									style={{
										textAlign: 'center',
										padding: '0px 20px',
										color: '#666',
									}}
								>
									<h3
										style={{
											margin: '0 0 8px 0',
											fontSize: '18px',
											fontWeight: '600',
											color: '#333',
										}}
									>
										No Recognitions Yet
									</h3>
									<p style={{ margin: '0', fontSize: '14px', color: '#595959' }}>
										Your earned recognitions will appear here once approved.
									</p>
								</div>
							}
						/>
					</div>
				</div>
			)}
		</>
	);
};

export default MyBadgesList;
